module.exports = __webpack_public_path__ + "static/plain-labels-15a9a2fa993d29b193208c8884f62572.png";